/**
 *  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createContext, useContext } from "react";
import { IResizeContext } from "./ResizeTypes";

export const ResizeContext = createContext<IResizeContext>({});

export function useResizeContext(): IResizeContext {
	return useContext(ResizeContext);
}
